import { ThirdPartyModelTypes } from "./constants";

export const thirdPartyParamsOrder: Record<ThirdPartyModelTypes, string[]> = {
  wenxin: ["style", "size"],
  draft: [],
  monkey: [],
};
